import { createSelector } from 'reselect';
import { getActiveProductId } from './products';
import {
    getActiveSewpat,
    getFabricDisplayLengthBySize,
    getFabricLengthBySize,
    getFashionSize,
    getSelectedSewpatOptions,
} from './sewpats';

/**
 * Reducer for the price scale.
 *
 * @param state
 * @param action
 * @returns {*}
 */
export default ( state, action ) => {
    switch (action.type) {
        default:
            return state;
    }
};

const getPrices = state => state.appSettings.prices;
const getPriceActions = state => state.appSettings.priceActions;

const getActiveFabricId = state => state.stolo.fabric.fabricId;
const getFabricLength = state => getFabricLengthBySize(
    getActiveSewpat(state),
    getFashionSize(state),
    getSelectedSewpatOptions(state),
);
const getFabricDisplayLength = state => getFabricDisplayLengthBySize(
    getActiveSewpat(state),
    getFashionSize(state),
    getSelectedSewpatOptions(state),
);

export const isShippingFree = state => {
    const actions = getPriceActions(state);
    if (actions.shippingFree && actions.shippingFree.start) {
        const start = Date.parse(actions.shippingFree.start);
        const end = Date.parse(actions.shippingFree.end);
        const now = Date.now();
        return now > start && now < end;
    }
    return false;
};

export const getCurrentPriceActionEndDate = state => {
    if (isShippingFree(state)) {
        return getShippingFreeEndDate(state);
    }
    return '99.99.9999';
};

export const getShippingFreeEndDate = state => {
    if (isShippingFree(state)) {
        const actions = getPriceActions(state);
        const endDate = new Date(actions.shippingFree.end);
        return endDate.toLocaleDateString(
            'de-DE',
            {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
            },
        );
    }
    throw 'No Shipping free action active';
};

export const getActiveFabricPrice = createSelector(
    [getActiveFabricId, getPrices],
    ( fabricId, prices ) => prices[fabricId],
);

export const getSewpatPrice = createSelector(
    [getActiveSewpat],
    sewpat => {
        const amount = sewpat.price.default;
        return amount.toFixed(2) || null;
    },
);

export const getSewpatNetPrice = createSelector(
    [getActiveSewpat],
    sewpat => {
        const amount = sewpat.price.default;
        return (
            amount / 1.19
        ).toFixed(5) || null;
    },
);

const getReducedSchnoffPrice = state => {
    const schnoffPrice = parseFloat(getPrice(state));
    const comparePrice = Math.ceil(schnoffPrice / 10) * 10;
    const diff = Math.abs(schnoffPrice - comparePrice);
    const remainder = 10 - diff;
    if (remainder <= 2) {
        return schnoffPrice - remainder - 0.02;
    }
    return schnoffPrice;
};

const getRegularSchnoffPrice = state => {
    const productVariation = getActiveProductId(state);
    if (productVariation === 'sewingpattern') {
        return getReducedSchnoffPrice(state);
    }
    const schnoffPrice = parseFloat(getPrice(state));
    const comparePrice = Math.ceil(schnoffPrice / 10) * 10;
    const diff = Math.abs(schnoffPrice - comparePrice);
    const remainder = 10 - diff;
    if (diff <= 2) {
        return schnoffPrice + 5;
    }
    var strikeThroughPrice = schnoffPrice + 9.98;
    if (remainder > 6) {
        strikeThroughPrice = schnoffPrice + 6;
    }
    else {
        strikeThroughPrice = schnoffPrice + remainder + 1.98;
    }
    return strikeThroughPrice;
};

export const getSchnoffPrice = state => {
    const price = isShippingFree(state)
        ? getRegularSchnoffPrice(state)
        : getReducedSchnoffPrice(state);

    return price;
};

export const getStrikeThroughPrice = state => {
    return isShippingFree(state)
        ? getReducedSchnoffPrice(state)
        : getRegularSchnoffPrice(state);
};

const getPrice = createSelector(
    [
        getActiveFabricId,
        getPrices,
        getActiveSewpat,
        getFabricLength,
        getActiveProductId],
    ( fabricId, prices, sewpat, fabricLength, productVariation ) => {
        const fabricPrice = prices[fabricId].amount * fabricLength * 0.01;
        const sewpatPrice = sewpat.price.default || 0;
        var FabricPrice = 0;
        var SewpatPrice = 0;
        if (productVariation === 'schnoff' || productVariation === 'fabric') {
            FabricPrice = Math.ceil(fabricPrice) + 3.98;
        }
        if (productVariation === 'schnoff' || productVariation ===
            'sewingpattern') {
            SewpatPrice = sewpatPrice;
        }
        const Price = FabricPrice + SewpatPrice;
        return Price.toFixed(2) || null;
    },
);

export const getSchnoffNetPrice = state => {
    const gross = getSchnoffPrice(state);
    const Net = gross / 1.19;
    return Net.toFixed(5) || null;
};

export const getBasePrice = createSelector(
    [getSchnoffPrice, getFabricDisplayLength],
    ( price, length ) => (
        price / length / 0.01
    ).toFixed(2),
);



// WEBPACK FOOTER //
// ./src/reducers/prices.js